import { Dropdown, DropdownButton } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function ToggelerLang() {
  const { defaultLang, languages } = useSelector(
    (state) => state.getLanguageSettingsSlicer.data || {}
  );

  const handleLangChange = (lang) => {
    if (!lang?.slug) return;

    localStorage.setItem("langSlug", lang.slug);
    window.location.reload();
  };

  return (
    <DropdownButton
      id="dropdown-basic-button"
      className="switch-lang-button bg-primary after:hidden rounded-lg after:text-white mb-[20px] after:translate-y-1"
      title={
        <div className="relative flex items-center group">
          <span className="text-white">{defaultLang?.slug}</span>
        </div>
      }
    >
      {languages?.length ? (
        languages.map((lang, index) => (
          <Dropdown.Item key={index} onClick={() => handleLangChange(lang)}>
            {lang?.name}
          </Dropdown.Item>
        ))
      ) : (
        <Dropdown.Item disabled>No Languages</Dropdown.Item>
      )}
    </DropdownButton>
  );
}
